import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/profil',
    name: 'profil',
    component: () => lazyLoadView(import('@views/admin/Profil.vue')),
    meta: {
      title: 'Profil',
    },
  },
];
